import { MoonIcon, SunIcon } from "@heroicons/react/24/outline";
import React from "react";
import useThemeStore from "../store/themeStore";

const ThemeSwitch: React.FC = () => {
  const { theme, setTheme } = useThemeStore();

  const handleThemeToggle = () => {
    setTheme(theme === "light" ? "dark" : "light");
  };

  if (theme == "light") {
    return <MoonIcon onClick={handleThemeToggle} width={30} />;
  }

  if (theme == "dark") {
    return <SunIcon onClick={handleThemeToggle} width={30} className="text-white"/>;
  }
};

export default ThemeSwitch;
